<template>
    <a v-bind:href="url" class="card" target="_blank" rel="noopener noreferrer">
        <div class="card-content">
            <p class="card-body">
                <span class="card-title">{{ title }}</span>
                <span class="card-time">{{ published_on | moment("from","now") }}</span>                                
            </p>                                    
            <img v-bind:src="imageurl" class="card-image">
        </div>
    </a>    
</template>

<script>
export default {
    name: 'news',
    props: ['imageurl','url','title','published_on'],
    methods: {       
    }    
}
</script>

<style lang="scss" scoped>
.card {
    padding: 16px;
    border-radius: 4px;

    background: #FFFFFF;
    position: relative;
    box-shadow: 0 0 50px 5px rgba(201,201,201,.25);
    transition: all .2s ease-in-out; 
    text-decoration: none;      

    &:hover {
        transform: scale(1.1);
        box-shadow: 0 0 50px 10px rgba(201,201,201,.60);
        z-index: 2;
        cursor: pointer;
    }

    &-image {
        width: 100%;
        height: 118px;
        object-fit: contain;    
    }

    span.card-title {
        max-height: 80px;
        overflow: hidden;
        color: #6CA9EA;
        text-decoration: underline;            
    }

    &-body {
        margin-right: 8px;
        display: grid;
        grid-template-rows: 1fr 1fr;

        span {
            display: block;
        }
    }

    &-content {
        // text-transform: uppercase;
        font-size: 16px;
        color: #AABBC7;  //#9A9E9E;

        display: grid;
        grid-template-columns: 2fr 1fr; 

        p {
            font-size: 0.875rem;
            text-transform: capitalize;            
        }

        @media (max-width: 480px) {
            font-size: 14px;
        }        
    }
}

</style>


// WEBPACK FOOTER //
// src/components/News.vue